var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("editor", {
        attrs: { init: _vm.init },
        model: {
          value: _vm.editorValue,
          callback: function ($$v) {
            _vm.editorValue = $$v
          },
          expression: "editorValue",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }